module.exports = __webpack_public_path__ + "img/black.00fbbf1f.png";